import { render, staticRenderFns } from "./Fuse.vue?vue&type=template&id=2935c388"
import script from "./Fuse.vue?vue&type=script&lang=js"
export * from "./Fuse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports